import { LearnModule } from '../../../../../common/src/model.ts';
import { failureScreenIds } from '../learn_failure_screen.tsx';
import { RhythmExercisePage, RhythmExerciseProps, RhythmExerciseVariant } from './rhythm_echo_page.tsx';

// Sing Rhythm (issue #3723), Rhythm module 2: hear a rhythm, sing it back on one note. It is Rhythm
// Echo's page (rhythm_echo_page.tsx) with the voice in place of the thumb - the same patterns,
// warm-up, scoring, result and summary - so everything it does is described there, under "Sing
// Rhythm"; this file only names the variant.

export const singRhythmPageId = 'sing-rhythm-page';

const singRhythmIdPrefix = 'sing-rhythm';
const failureIds = failureScreenIds(singRhythmIdPrefix);
export const singRhythmFailureScreenId = failureIds.screen;
export const singRhythmRetryButtonId = failureIds.retry;
export const singRhythmFailureBackButtonId = failureIds.back;

const singRhythmVariant: RhythmExerciseVariant = {
  module: LearnModule.SingRhythm,
  input: 'voice',
  pageId: singRhythmPageId,
  idPrefix: singRhythmIdPrefix,
};

export const SingRhythmPage = (props: RhythmExerciseProps) => (
  <RhythmExercisePage variant={singRhythmVariant} {...props} />
);
